import HttpFactory from '../HttpFactory'
import type IBasicArrayResponse from '../interfaces/IBasicArrayResponse'

class AmenitiesModule extends HttpFactory {
  private RESOURCE = 'api/amenities'

  async getAllAmenities () {
    return await this.callUseAsyncData<IBasicArrayResponse>(
      'GET',
      `${this.RESOURCE}`
    )
  }
}

export default AmenitiesModule
